import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import UrlParse from 'url-parse';
import TitleSection from '~/components/atoms/Editorial/TitleSection.vue';
import SubtitleSection from '~/components/atoms/Editorial/SubtitleSection.vue';
import SimpleParagraph from '~/components/atoms/Editorial/SimpleParagraph.vue';
import { formatPrismicImage } from '~/helpers/image-helper';
import { EMPTY_PIXEL } from '~/const/images';
export default {
  name: 'DisplayProductSlider',
  components: {
    TitleSection: TitleSection,
    SubtitleSection: SubtitleSection,
    SimpleParagraph: SimpleParagraph
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      showCarousel: false,
      slideNumber: 5
    };
  },
  computed: {
    title: function title() {
      return this.payload.primary.title[0] || {};
    },
    titleColor: function titleColor() {
      return this.payload.primary.title_color;
    },
    subtitle: function subtitle() {
      return this.payload.primary.subtitle[0] || {};
    },
    subtitleColor: function subtitleColor() {
      return this.payload.primary.subtitle_color;
    },
    paragraph: function paragraph() {
      return this.payload.primary.paragraph;
    },
    readMore: function readMore() {
      return this.payload.primary.read_more === 'Yes';
    },
    images: function images() {
      return this.payload.items.map(function (item) {
        var small = formatPrismicImage(item.image.url, ['w_375']) || EMPTY_PIXEL;
        var medium = formatPrismicImage(item.image.url, ['w_375,dpr_2']) || EMPTY_PIXEL;
        var large = formatPrismicImage(item.image.url, ['w_1440']) || EMPTY_PIXEL;
        var xlarge = formatPrismicImage(item.image.url, ['w_1440,dpr_2']) || EMPTY_PIXEL;
        return {
          src: large,
          srcset: "".concat(small, " 375w, ").concat(medium, " 750w, ").concat(large, " 1440w, ").concat(xlarge, " 2880w"),
          text: item.title,
          url: new UrlParse(item.url.url || '').pathname,
          tracking: {
            data: {
              event_category: item.event_category,
              event_action: item.event_action,
              event_label: item.event_label
            }
          }
        };
      });
    },
    slideCount: function slideCount() {
      return [[320, 2.5], [768, 3.5], [1024, this.slideNumber]];
    }
  },
  mounted: function mounted() {
    this.showCarousel = true;
    this.slideNumber = this.$refs.carousel.slideCount;
  }
};